import React from "react";

function FooterComponent() {
  return (
    <div className="footer-bottom-new">
      <div className="container">
        <div className="footer-bottom-inner">
          <span>
            GoWave Automation Lab &copy; {new Date().getFullYear()} — All
            rights reserved.
          </span>
          <span className="footer-bottom-right">
            Registered Partnership Firm — Kolkata, India
          </span>
        </div>
      </div>
    </div>
  );
}

export default FooterComponent;
